import {
  selectStudyPeriodEndDate,
  selectStudyPeriodStartDate,
  useCohortDefinitionStore,
} from '@verantos-dev/app-state-cohort-definition';

/**
 * Pure Zustand read for the study period card. Returns the start/end
 * dates as ISO strings (YYYY-MM-DD) — formatting happens in the
 * component.
 */
export const useStudyPeriodSection = () => {
  const startDate = useCohortDefinitionStore(selectStudyPeriodStartDate);
  const endDate = useCohortDefinitionStore(selectStudyPeriodEndDate);

  return {
    startDate,
    endDate,
    isDefined: !!(startDate && endDate),
  };
};
